import { createContext, useContext } from "react";


export const AdminUserContext = createContext(null);

export const useAdminUser = () => useContext(AdminUserContext);

export const useAdminRole = () => {
  const user = useAdminUser();
  return (user?.role || "").toLowerCase();
};


export const RoleGate = ({ allow, hide, children }) => {
  const role = useAdminRole();
  if (allow) return allow.map((r) => r.toLowerCase()).includes(role) ? children : null;
  if (hide) return hide.map((r) => r.toLowerCase()).includes(role) ? null : children;
  return children;
};
